import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import { __, _n, sprintf } from '@wordpress/i18n';
import { Button, MenuGroup, Spinner, TextControl, withSpokenMessages } from '@wordpress/components';
import { Component, Fragment } from '@wordpress/element';
import { compose, withInstanceId, withState } from '@wordpress/compose';
import { escapeRegExp, findIndex } from 'lodash';
import Gridicon from 'gridicons';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import { buildTermsTree } from './hierarchy';
import SearchListItem from './item';
import Tag from '../tag';
var defaultMessages = {
  clear: __('Clear all selected items', 'woocommerce-admin'),
  list: __('Results', 'woocommerce-admin'),
  noItems: __('No items found.', 'woocommerce-admin'),
  noResults: __('No results for %s', 'woocommerce-admin'),
  search: __('Search for items', 'woocommerce-admin'),
  selected: function selected(n) {
    return sprintf(_n('%d item selected', '%d items selected', n, 'woocommerce-admin'), n);
  },
  updated: __('Search results updated.', 'woocommerce-admin')
};
/**
 * Component to display a searchable, selectable list of items.
 */

export var SearchListControl =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchListControl, _Component);

  function SearchListControl() {
    var _this;

    _classCallCheck(this, SearchListControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchListControl).apply(this, arguments));
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    _this.onRemove = _this.onRemove.bind(_assertThisInitialized(_this));
    _this.onClear = _this.onClear.bind(_assertThisInitialized(_this));
    _this.isSelected = _this.isSelected.bind(_assertThisInitialized(_this));
    _this.defaultRenderItem = _this.defaultRenderItem.bind(_assertThisInitialized(_this));
    _this.renderList = _this.renderList.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchListControl, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          onSearch = _this$props.onSearch,
          search = _this$props.search;

      if (search !== prevProps.search && 'function' === typeof onSearch) {
        onSearch(search);
      }
    }
  }, {
    key: "onRemove",
    value: function onRemove(id) {
      var _this$props2 = this.props,
          isSingle = _this$props2.isSingle,
          onChange = _this$props2.onChange,
          selected = _this$props2.selected;
      return function () {
        if (isSingle) {
          onChange([]);
        }

        var i = findIndex(selected, {
          id: id
        });
        onChange([].concat(_toConsumableArray(selected.slice(0, i)), _toConsumableArray(selected.slice(i + 1))));
      };
    }
  }, {
    key: "onSelect",
    value: function onSelect(item) {
      var _this2 = this;

      var _this$props3 = this.props,
          isSingle = _this$props3.isSingle,
          onChange = _this$props3.onChange,
          selected = _this$props3.selected;
      return function () {
        if (_this2.isSelected(item)) {
          _this2.onRemove(item.id)();

          return;
        }

        if (isSingle) {
          onChange([item]);
        } else {
          onChange([].concat(_toConsumableArray(selected), [item]));
        }
      };
    }
  }, {
    key: "onClear",
    value: function onClear() {
      this.props.onChange([]);
    }
  }, {
    key: "isSelected",
    value: function isSelected(item) {
      return -1 !== findIndex(this.props.selected, {
        id: item.id
      });
    }
  }, {
    key: "getFilteredList",
    value: function getFilteredList(list, search) {
      var isHierarchical = this.props.isHierarchical;

      if (!search) {
        return isHierarchical ? buildTermsTree(list) : list;
      }

      var messages = _objectSpread({}, defaultMessages, {}, this.props.messages);

      var re = new RegExp(escapeRegExp(search), 'i');
      this.props.debouncedSpeak(messages.updated);
      var filteredList = list.map(function (item) {
        return re.test(item.name) ? item : false;
      }).filter(Boolean);
      return isHierarchical ? buildTermsTree(filteredList, list) : filteredList;
    }
  }, {
    key: "defaultRenderItem",
    value: function defaultRenderItem(args) {
      return createElement(SearchListItem, args);
    }
  }, {
    key: "renderList",
    value: function renderList(list) {
      var _this3 = this;

      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$props4 = this.props,
          isSingle = _this$props4.isSingle,
          search = _this$props4.search;
      var renderItem = this.props.renderItem || this.defaultRenderItem;

      if (!list) {
        return null;
      }

      return list.map(function (item) {
        return createElement(Fragment, {
          key: item.id
        }, renderItem({
          item: item,
          isSelected: _this3.isSelected(item),
          onSelect: _this3.onSelect,
          isSingle: isSingle,
          search: search,
          depth: depth
        }), _this3.renderList(item.children, depth + 1));
      });
    }
  }, {
    key: "renderListSection",
    value: function renderListSection() {
      var _this$props5 = this.props,
          isLoading = _this$props5.isLoading,
          search = _this$props5.search;
      var list = this.getFilteredList(this.props.list, search);

      var messages = _objectSpread({}, defaultMessages, {}, this.props.messages);

      if (isLoading) {
        return createElement("div", {
          className: "woocommerce-search-list__list is-loading"
        }, createElement(Spinner, null));
      }

      if (!list.length) {
        return createElement("div", {
          className: "woocommerce-search-list__list is-not-found"
        }, createElement("span", {
          className: "woocommerce-search-list__not-found-icon"
        }, createElement(Gridicon, {
          icon: "notice-outline",
          role: "img",
          "aria-hidden": "true",
          focusable: "false"
        })), createElement("span", {
          className: "woocommerce-search-list__not-found-text"
        }, search ? sprintf(messages.noResults, search) : messages.noItems));
      }

      return createElement(MenuGroup, {
        label: messages.list,
        className: "woocommerce-search-list__list"
      }, this.renderList(list));
    }
  }, {
    key: "renderSelectedSection",
    value: function renderSelectedSection() {
      var _this4 = this;

      var _this$props6 = this.props,
          isLoading = _this$props6.isLoading,
          isSingle = _this$props6.isSingle,
          selected = _this$props6.selected;

      var messages = _objectSpread({}, defaultMessages, {}, this.props.messages);

      if (isLoading || isSingle || !selected) {
        return null;
      }

      var selectedCount = selected.length;
      return createElement("div", {
        className: "woocommerce-search-list__selected"
      }, createElement("div", {
        className: "woocommerce-search-list__selected-header"
      }, createElement("strong", null, messages.selected(selectedCount)), selectedCount > 0 ? createElement(Button, {
        isLink: true,
        isDestructive: true,
        onClick: this.onClear,
        "aria-label": messages.clear
      }, __('Clear all', 'woocommerce-admin')) : null), selected.map(function (item, i) {
        return createElement(Tag, {
          key: i,
          label: item.name,
          id: item.id,
          remove: _this4.onRemove
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          _this$props7$classNam = _this$props7.className,
          className = _this$props7$classNam === void 0 ? '' : _this$props7$classNam,
          search = _this$props7.search,
          setState = _this$props7.setState;

      var messages = _objectSpread({}, defaultMessages, {}, this.props.messages);

      return createElement("div", {
        className: "woocommerce-search-list ".concat(className)
      }, this.renderSelectedSection(), createElement("div", {
        className: "woocommerce-search-list__search"
      }, createElement(TextControl, {
        label: messages.search,
        type: "search",
        value: search,
        onChange: function onChange(value) {
          return setState({
            search: value
          });
        }
      })), this.renderListSection());
    }
  }]);

  return SearchListControl;
}(Component);
SearchListControl.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * Whether the list of items is hierarchical or not. If true, each list item is expected to
   * have a parent property.
   */
  isHierarchical: PropTypes.bool,

  /**
   * Whether the list of items is still loading.
   */
  isLoading: PropTypes.bool,

  /**
   * Restrict selections to one item.
   */
  isSingle: PropTypes.bool,

  /**
   * A complete list of item objects, each with id, name properties. This is displayed as a
   * clickable/keyboard-able list, and possibly filtered by the search term (searches name).
   */
  list: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })),

  /**
   * Messages displayed or read to the user. Configure these to reflect your object type.
   * See `defaultMessages` above for examples.
   */
  messages: PropTypes.shape({
    /**
     * A more detailed label for the "Clear all" button, read to screen reader users.
     */
    clear: PropTypes.string,

    /**
     * Label for the list of selectable items, only read to screen reader users.
     */
    list: PropTypes.string,

    /**
     * Message to display when the list is empty (implies nothing loaded from the server
     * or parent component).
     */
    noItems: PropTypes.string,

    /**
     * Message to display when no matching results are found. %s is the search term.
     */
    noResults: PropTypes.string,

    /**
     * Label for the search input
     */
    search: PropTypes.string,

    /**
     * Label for the selected items. This is actually a function, so that we can pass
     * through the count of currently selected items.
     */
    selected: PropTypes.func,

    /**
     * Label indicating that search results have changed, read to screen reader users.
     */
    updated: PropTypes.string
  }),

  /**
   * Callback fired when selected items change, whether added, cleared, or removed.
   * Passed an array of item objects (as passed in via props.list).
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Callback fired when the search field is used.
   */
  onSearch: PropTypes.func,

  /**
   * Callback to render each item in the selection list, allows any custom object-type rendering.
   */
  renderItem: PropTypes.func,

  /**
   * The list of currently selected items.
   */
  selected: PropTypes.array.isRequired,
  // from withState
  search: PropTypes.string,
  setState: PropTypes.func,
  // from withSpokenMessages
  debouncedSpeak: PropTypes.func,
  // from withInstanceId
  instanceId: PropTypes.number
};
export default compose([withState({
  search: ''
}), withSpokenMessages, withInstanceId])(SearchListControl);
//# sourceMappingURL=index.js.map